import { render, staticRenderFns } from "./SearchProfiles.vue?vue&type=template&id=3546b1be&"
import script from "./SearchProfiles.vue?vue&type=script&lang=js&"
export * from "./SearchProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports